import * as React from 'react';
import { errorHandler } from '../../error/handler';
import { getMagazzino, getMagazzinoList } from '../../fetch/place/magazzino';
import { IMagazzino } from '../../interfaces/place/models';
import { normalizer } from '../../lib/normalizer';
import { useAppDispatch } from '../../store/hooks';
import { emptyAction, getAction, listAction } from '../../store/place/magazzino/actions';
import { IMagazzinoState } from '../../store/place/magazzino/types';
import { endActionToDoAction, startActionToDoAction } from '../../store/ui/actions';

export const useMagazzinoGet = (id: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!id) return;
			const actionToDo = 'get-magazzino';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const magazzino = await getMagazzino(id);
				dispatch(getAction(magazzino));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
		}
		effect();
	}, [dispatch, id])
}

export const useMagazzinoList = (query: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!query) return;
			const actionToDo = 'list-magazzino';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const { results, items: _items } = await getMagazzinoList();;
				_items.sort((itemA, itemB) => (!!itemA?.ordinamento && !!itemB.ordinamento) ? itemA.ordinamento - itemB.ordinamento : 0);
				const { list, items } = normalizer<number, IMagazzino>(_items, "id");
				const actionPayload: IMagazzinoState = {
					results,
					list,
					items
				}
				dispatch(listAction(actionPayload));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
			return () => {
				dispatch(emptyAction());
			}
		}
		effect();
	}, [dispatch, query])
}